<div class="relative mx-auto size-[20px]">
  <div class="bg-new-primary absolute left-0 top-0 h-full w-full rounded-full"></div>
  <div class="bg-new-primary absolute left-0 top-0 h-full w-full rounded-full"></div>
</div>
